//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import { get, call } from 'vuex-pathify'
import { UsesAuthenticatedUser, UsesRequestInviteModal } from '@/mixins'
import { reject } from 'lodash-es'

const relativeDateContext = (fromDay, toDay) => {
  if (fromDay === 1 && toDay !== 2) {
    return 'Yesterday'
  } else if (toDay === 1 && fromDay >= 28) {
    return 'Tomorrow'
  }
  return fromDay > toDay ? 'Yesterday' : toDay > fromDay ? 'Tomorrow' : 'Today'
}

export default {
  mixins: [ UsesAuthenticatedUser, UsesRequestInviteModal ],

  async asyncData ({ params, store, error }) {
    await store.dispatch('kintellCards/loadAdvisorForSlug', { ...params, error })
  },

  data () {
    return {
      isInviteRequestModalOpen: false,
      advisorsLocaleTime: null,
      updateTimeInterval: null,
      socialMediaLinks: {
        linkedin: { label: 'LinkedIn', icon: 'linkedin' },
        youtube: { label: 'YouTube', icon: 'youtube' },
        facebook: { label: 'Facebook', icon: 'facebook' },
        instagram: { label: 'Instagram', icon: 'instagram' },
        github: { label: 'GitHub', icon: 'github' },
        website: { label: 'Website', icon: 'globe' },
        researchGate: { label: 'ResearchGate', icon: 'researchgate' },
        twitter: { label: 'twitter', icon: 'twitter' },
      },
      girl: require('~kurfs/girl-sitting-on-laptop.svg'),
    }
  },

  head () {
    const title = this.user.fullName
    const description = 'Book ' + title + ' for a one-to-one video session on Kintell today.'
    return {
      title: this.user.fullName,
      meta: [
        { hid: 'description', property: 'description', content: description },
        { hid: 'og:title', property: 'og:title', content: title },
        { hid: 'og:description', property: 'og:description', content: description },
      ]
    }
  },

  computed: {
    ...get({
      allkintellCards: 'kintellCards/allKintellCards',
      isCardsLoading: 'kintellCards/allKintellCardsLoading',
      user: 'kintellCards/activeUser',
    }),
    languages () {
      return this.user.languagesSpoken.join(', ')
    },
    hasASocialMediaLink () {
      return reject(this.socialMediaLinks, (value, key) => !this.user[key]).length > 0
    },
    url () {
      return window.location.href
    }
  },

  created () {
    this.setCurrentAdvisorsTime()
    const tenSeconds = 1000 * 10
    this.updateTimeInterval = setInterval(this.setCurrentAdvisorsTime, tenSeconds)
  },

  mounted () {
    this.loadRelated()
  },

  methods: {
    ...call({
      loadRelated: 'kintellCards/loadAllKintellCards'
    }),
    setCurrentAdvisorsTime () {
      const advisorsTZ = moment.tz(this.user.timezone)
      const advisorsTime = moment().utcOffset(advisorsTZ.format('Z'))

      const ourTZ = moment.tz.guess()
      const ourTime = moment().utcOffset(ourTZ)

      this.advisorsLocaleTime = advisorsTime.format('HH:mm') + ' ' + relativeDateContext(ourTime.format('D'), advisorsTime.format('D'))
    }
  }
}
